import * as React from 'react';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import * as style from './HeartFavoriteButton.css';
import { IFavoriteButtonProps } from '../../../types/newbuilding/favorite';

export function HeartFavoriteButton({ isFavorite, onClick }: IFavoriteButtonProps) {
  const icon = isFavorite ? (
    <IconToggleHeartOn16 color="icon-negative-default" />
  ) : (
    <IconToggleHeartOff16 color="icon-inverted-default" />
  );
  const dataTestId = isFavorite ? 'RemoveFavoriteHeartButton' : 'AddFavoriteHeartButton';

  return (
    <button onClick={onClick} className={style['favorite_button']} data-testid={dataTestId}>
      {icon}
    </button>
  );
}
